import { createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = {
  viewBox: "0 0 18 18",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}
const _hoisted_2 = /*#__PURE__*/_createVNode("path", {
  "fill-rule": "evenodd",
  "clip-rule": "evenodd",
  d: "M1 0C0.622759 0 0.277619 0.212299 0.107481 0.549001C-0.0626571 0.885702 -0.028833 1.28949 0.194949 1.5932L5.89474 9.32863V17C5.89474 17.3646 6.09317 17.7003 6.41259 17.8761C6.732 18.0519 7.12178 18.0399 7.42979 17.8448L11.6403 15.1782C11.9298 14.9948 12.1053 14.676 12.1053 14.3333V9.32863L17.8051 1.5932C18.0288 1.28949 18.0627 0.885702 17.8925 0.549001C17.7224 0.212299 17.3773 0 17 0H1ZM7.6998 8.4068L2.979 2H15.021L10.3002 8.4068C10.1736 8.57866 10.1053 8.78653 10.1053 9V13.783L7.89474 15.183V9C7.89474 8.78653 7.82643 8.57866 7.6998 8.4068Z",
  fill: "currentColor"
}, null, -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createBlock("svg", _hoisted_1, [
    _hoisted_2
  ]))
}